import React from 'react';
import './Experience.css';

const Experience = () => {
  const qualifications = [
    {
      icon: 'fas fa-certificate',
      title: 'Chartered Professional Accountant (CPA)',
      description: 'Licensed CPA with active certification since 2008'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Master of Business Administration (MBA)',
      description: 'Finance Specialization, University of Toronto, 2007'
    },
    {
      icon: 'fas fa-award',
      title: 'Bachelor of Commerce',
      description: 'Accounting Major, McGill University, 2005'
    }
  ];

  const timeline = [
    {
      date: '2018 - Present',
      title: 'Senior Financial Consultant',
      company: 'Independent Practice - Providing comprehensive financial services to diverse clientele'
    },
    {
      date: '2012 - 2018',
      title: 'Senior Manager',
      company: 'PricewaterhouseCoopers - Led audit teams and provided advisory services to major corporations'
    },
    {
      date: '2008 - 2012',
      title: 'Financial Analyst',
      company: 'Deloitte & Touche - Specialized in tax preparation and financial analysis'
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Experience & Qualifications</h2>
          <p className="section-description">Professional credentials and career highlights</p>
        </div>
        <div className="experience-content">
          <div className="experience-left">
            <div className="qualifications">
              <h3>Professional Qualifications</h3>
              {qualifications.map((qualification, index) => (
                <div key={index} className="qualification-item fade-in">
                  <i className={qualification.icon}></i>
                  <div>
                    <h4>{qualification.title}</h4>
                    <p>{qualification.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="experience-right">
            <div className="timeline">
              <h3>Career Timeline</h3>
              {timeline.map((item, index) => (
                <div key={index} className="timeline-item fade-in">
                  <div className="timeline-date">{item.date}</div>
                  <div className="timeline-content">
                    <h4>{item.title}</h4>
                    <p>{item.company}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;